import { Component, inject, OnInit, signal, ChangeDetectionStrategy } from '@angular/core';
import { take, timer } from 'rxjs';
import { Flavour } from '../../services/web-config/web-config.helper';
import { WebConfigService } from '../../services/web-config/web-config.service';
import { WINDOW } from '../../providers/window/window.provider';

@Component({
  selector: 'app-loader',
  templateUrl: './loader.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  styleUrls: ['./loader.component.scss'],
})
export class LoaderComponent implements OnInit {
  #window = inject(WINDOW);
  #webConfig = inject(WebConfigService);
  show = signal(true);
  isBetwayLinkApp = signal(false);

  constructor() {
    timer(3000)
      .pipe(take(1))
      .subscribe(() => {
        this.show.set(false);
      });
  }

  ngOnInit(): void {
    this.show.set(true);
    this.isBetwayLinkApp.set(this.#isBetwayLinkApp());
  }

  #isBetwayLinkApp(): boolean {
    return this.#window.location.hostname.includes('link') && this.#webConfig.orgId === Flavour.Betway;
  }
}
